enum ContractRefundPaymentStatusTriggers {
  CONTRACT_REFUNDS_REMITTANCE_ADVICE = 'CONTRACT_REFUNDS_REMITTANCE_ADVICE',
}
export default ContractRefundPaymentStatusTriggers;

export type VerifyContractRefundPaymentStatusTriggers = Utils.VerifyExtends<
  Model.Enum.ContractRefundPaymentStatusTriggers,
  Utils.ValueOf<typeof ContractRefundPaymentStatusTriggers>
>;
